import { render, staticRenderFns } from "./ClaimView.vue?vue&type=template&id=160814f5&scoped=true&"
import script from "./ClaimView.vue?vue&type=script&lang=js&"
export * from "./ClaimView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160814f5",
  null
  
)

export default component.exports